export default __webpack_public_path__ + "static/media/Overview.d15de510.png";